import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';
import {
  OverviewChartTimeframe,
  OverviewChartType,
  SortingDirection,
  SortingToggleOptions,
} from '../../screens/Overview/types';

interface UIState {
  overviewChartTimeframe: OverviewChartTimeframe;
  overviewChartType: OverviewChartType;
  overviewChartPercentage: boolean;
  sorting: SortingToggleOptions;
  sortingDirection: SortingDirection;
}

const initialState: UIState = {
  overviewChartTimeframe: OverviewChartTimeframe.All,
  overviewChartType: OverviewChartType.ProfitOnly,
  overviewChartPercentage: true,
  sorting: SortingToggleOptions.Diversity,
  sortingDirection: SortingDirection.Descending,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setSorting: (state, action: PayloadAction<SortingToggleOptions>) => {
      state.sorting = action.payload;
    },
    setOverviewChartPercentage: (state, action: PayloadAction<boolean>) => {
      state.overviewChartPercentage = action.payload;
    },
    setOverviewChartTimeframe: (
      state,
      action: PayloadAction<OverviewChartTimeframe>,
    ) => {
      state.overviewChartTimeframe = action.payload;
    },
    setOverviewChartType: (state, action: PayloadAction<OverviewChartType>) => {
      state.overviewChartType = action.payload;
    },
    setSortingDirection: (state, action: PayloadAction<SortingDirection>) => {
      state.sortingDirection = action.payload;
    },
  },
});

export const {
  setSorting,
  setSortingDirection,
  setOverviewChartTimeframe,
  setOverviewChartType,
  setOverviewChartPercentage,
} = uiSlice.actions;

export const selectOverviewChartTimeframe = (state: RootState) =>
  state.ui.overviewChartTimeframe;
export const selectSorting = (state: RootState) => state.ui.sorting;
export const selectSortingDirection = (state: RootState) =>
  state.ui.sortingDirection;
export const selectOverviewChartPercentage = (state: RootState) =>
  state.ui.overviewChartPercentage;
export const selectOverviewChartType = (state: RootState) =>
  state.ui.overviewChartType;

export default uiSlice.reducer;
